import React from "react";
import MicroFrontend from "../microFrontend/MicroFrontend.tsx";

export interface IQuestionnairesListOverviewProps {}

function QuestionnairesListOverview(props: IQuestionnairesListOverviewProps) {
    return (
        <>
            <MicroFrontend />
        </>
    );
}

export default QuestionnairesListOverview;
